module.exports = __webpack_public_path__ + "img/code.066baf1a.png";